import { arrayOf } from 'normalizr'
import uniq from 'lodash.uniq'

import { fetch, schemas } from '../utils/fetch'
import { ENDPOINT_ALBUMS, ENDPOINT_FAVOURITE_ALBUMS } from '../constants'
import { SAVE_ALBUM_SUCCESS, DELETE_ALBUM, SET_FAVOURITE_ALBUM, REMOVE_FAVOURITE_ALBUM } from './album'
import { UNSHARE_ALBUM } from './share'

const ALBUMS_REQUEST = 'blayzr/albums/REQUEST'
const ALBUMS_SUCCESS = 'blayzr/albums/SUCCESS'
const ALBUMS_FAILURE = 'blayzr/albums/FAIL'

const FAVOURITE_ALBUMS_REQUEST = 'blayzr/albums/FAVOURITES_REQUEST'
const FAVOURITE_ALBUMS_SUCCESS = 'blayzr/albums/FAVOURITES_SUCCESS'
const FAVOURITE_ALBUMS_FAILURE = 'blayzr/albums/FAVOURITES_FAIL'

const initialListState = {
  data: null,
  fetching: false,
  error: null
}

const initialState = {
  all: initialListState,
  favourites: initialListState
}

export default function reducer (state = initialState, action = {}) {
  const { type } = action
  switch (type) {
    case ALBUMS_REQUEST:
    case ALBUMS_SUCCESS:
    case ALBUMS_FAILURE:
    case SAVE_ALBUM_SUCCESS:
    case UNSHARE_ALBUM:
      return {
        ...state,
        all: listReducer(state.all, action)
      }
    case FAVOURITE_ALBUMS_REQUEST:
    case FAVOURITE_ALBUMS_SUCCESS:
    case FAVOURITE_ALBUMS_FAILURE:
    case SET_FAVOURITE_ALBUM:
    case REMOVE_FAVOURITE_ALBUM:
      return {
        ...state,
        favourites: listReducer(state.favourites, action)
      }
    case DELETE_ALBUM:
      return {
        all: listReducer(state.all, action),
        favourites: listReducer(state.favourites, action)
      }
    default:
      return state
  }
}

function listReducer (state = initialListState, action) {
  const { type, payload, meta } = action
  switch (type) {
    case ALBUMS_REQUEST:
    case FAVOURITE_ALBUMS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case ALBUMS_SUCCESS:
    case FAVOURITE_ALBUMS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: uniq((state.data || []).concat(payload.result.records))
      }
    case ALBUMS_FAILURE:
    case FAVOURITE_ALBUMS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error
      }
    case SAVE_ALBUM_SUCCESS:
    case SET_FAVOURITE_ALBUM:
      // Append album to album group
      if (state.data && state.data.indexOf(meta.id) === -1) {
        return {
          ...state,
          data: state.data.concat(meta.id)
        }
      }
      return state
    case DELETE_ALBUM:
    case REMOVE_FAVOURITE_ALBUM:
      // Remove album from album group
      if (state.data) {
        return {
          ...state,
          data: state.data.filter(id => id !== meta.id)
        }
      }
      return state
    case UNSHARE_ALBUM:
      // Remove album that you unshare yourself from
      console.log('unshare', state, meta)
      if (state.data && meta.removeFromAlbums) {
        return {
          ...state,
          data: state.data.filter(id => id !== meta.albumID)
        }
      }
      return state
    default:
      return state
  }
}

export function albumsRequest () {
  return {
    type: ALBUMS_REQUEST
  }
}

export function albumsSuccess (data) {
  return {
    type: ALBUMS_SUCCESS,
    payload: data
  }
}

export function albumsFailure (error) {
  return {
    type: ALBUMS_FAILURE,
    payload: { error }
  }
}

export function favouriteAlbumsRequest () {
  return {
    type: FAVOURITE_ALBUMS_REQUEST
  }
}

export function favouriteAlbumsSuccess (data) {
  return {
    type: FAVOURITE_ALBUMS_SUCCESS,
    payload: data
  }
}

export function favouriteAlbumsFailure (error) {
  return {
    type: FAVOURITE_ALBUMS_FAILURE,
    payload: { error }
  }
}

const schema = {
  records: arrayOf(schemas.album)
}

export function fetchAlbums () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token,
      schema
    }
    dispatch(albumsRequest())
    return fetch(ENDPOINT_ALBUMS, options, dispatch).then(data => {
      dispatch(albumsSuccess(data))
    }, e => {
      dispatch(albumsFailure(e))
    })
  }
}

export function fetchFavouriteAlbums () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token,
      schema
    }
    dispatch(favouriteAlbumsRequest())
    fetch(ENDPOINT_FAVOURITE_ALBUMS, options, dispatch).then(data => {
      dispatch(favouriteAlbumsSuccess(data))
    }, e => {
      dispatch(favouriteAlbumsFailure(e))
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/albums.js